import { ReactNode } from "react";
import { useNotificationTemplateData } from "../use-notification-template-data";
import { InitialValuesProvider } from "./initial-values-provider";
import { getNotificationTemplateQueryToNotificationTemplateValueInput } from "../../utils/data-transform";

export function InitialValuesByTemplateId({
  id,
  children,
}: {
  id?: string;
  children: ReactNode;
}) {
  const { data } = useNotificationTemplateData(id);

  return (
    <InitialValuesProvider
      initialValues={getNotificationTemplateQueryToNotificationTemplateValueInput(
        data,
      )}
    >
      {children}
    </InitialValuesProvider>
  );
}
